import React from "react";
import { graphql } from "gatsby";
import GraphQLErrorList from "../components/graphql-error-list";
import Seo from "../components/seo";
import Layout from "../containers/layout-dark";

import PageHeader from "../components/page-header";
import NewsList from "../components/news-list";

export const query = graphql`
  fragment SanityImage on SanityMainImage {
    crop {
      _key
      _type
      top
      bottom
      left
      right
    }
    hotspot {
      _key
      _type
      x
      y
      height
      width
    }
    asset {
      _id
    }
  }

  query NewsCategoryQuery($skip: Int!, $limit: Int!, $id: String!, $slug: String!) {
    newsPage: sanityNewsPage {
      pageHeader {
        title
        subtitle
        description
      }
    }

    category: sanityNewsCategory(id: { eq: $id }) {
      id
      title
      description
      slug {
        current
      }
      pageMetaInfo {
        metaTitle
        metaDescription
      }
    }

    news: allSanityNews(
      sort: { fields: [publishedOn], order: DESC }
      filter: { slug: { current: { ne: null } }, category: { slug: { current: { eq: $slug } } } }
      limit: $limit
      skip: $skip
    ) {
      edges {
        node {
          id
          pageHeader {
            title
          }
          featuredImage {
            ...SanityImage
            alt
          }
          category {
            title
            slug {
              current
            }
          }
          slug {
            current
          }
        }
      }
    }

    newsCats: allSanityNewsCategory(
      sort: { fields: [order], order: ASC }
      filter: { slug: { current: { ne: null } } }
    ) {
      edges {
        node {
          id
          title
          slug {
            current
          }
        }
      }
    }
  }
`;

const NewsCategoryTemplate = (props) => {
  const { data, pageContext, errors } = props;
  const { currentPage, numPages } = pageContext;

  if (errors) {
    return (
      <Layout>
        <GraphQLErrorList errors={errors} />
      </Layout>
    );
  }

  const newsPage = (data || {}).newsPage;
  const category = (data || {}).category;
  const news = (data || {}).news.edges.filter(post => ((post.node.category && post.node.category.slug) ? post.node.category.slug.current : ``) === category.slug.current);
  const newsCats = (data || {}).newsCats;

  return (
    <Layout>
      <Seo
        title={category.pageMetaInfo?.metaTitle || newsPage.pageHeader.title + " | " + category.title}
        description={category.pageMetaInfo?.metaDescription || category.description}
      />

      {newsPage.pageHeader && <PageHeader {...newsPage.pageHeader} dark="true" titleWidth="xl" descWidth="md" isBlogMainPage={true}/>}
      {news && <NewsList news={news} newsCats={newsCats} category={category.slug.current} currentPage={currentPage} numPages={numPages} />}
    </Layout>
  );
};

export default NewsCategoryTemplate;
